export const Interactions = {
  AccountDataUpdate: 'account-data-update',
};
